<dx-validation-group #validationGroup>
    @if(shiftDetails){
        <div class="card border-0 shadow-sm pt-0 pb-4 mb-4">
            <div class="card-header fs-5 fw-medium">Shift Details</div>
            <div class="card-body">
                <div class="row g-3">
                    <div class="col-md-6">
                        <label class="form-label">Shift</label>
                        <dx-select-box
                            [(value)]="shiftDetails.shiftId"
                            [dataSource]="shiftDataSource"
                            displayExpr="name"
                            valueExpr="id"
                            [searchEnabled]="true"
                            [showClearButton]="true"
                            stylingMode="filled"
                            (onValueChanged)="onFieldChange()"
                            [readOnly]="isReadOnly"
                        >
                        </dx-select-box>
                    </div>
                    <div class="col-md-6">
                        <label class="form-label">Supervisor</label>
                        <pictured-item-select-box
                            [(value)]="shiftDetails.supervisorId"
                            [dataSource]="supervisorDataSource"
                            (valueChange)="onFieldChange()"
                            [validators]="[]"
                            [readOnly]="isReadOnly"
                        ></pictured-item-select-box>
                    </div>
                </div>
            </div>
        </div>
    }
</dx-validation-group>

